// FAQ Data for Different Pages
// Used for Structured Data (JSON-LD) and potentially UI FAQs

export const homepageFAQs = {
  questions: [
    {
      question: "What is JEE Challenger?",
      answer: "JEE Challenger is a comprehensive free online platform for JEE Main and Advanced preparation. It provides a wide range of study resources including study notes, previous year questions, an AI-powered tutor, syllabus tracker, and real-time exam updates - all completely free."
    },
    {
      question: "Is JEE Challenger completely free?",
      answer: "Yes! JEE Challenger is 100% free. All study materials, previous year questions, syllabus tracker, and most AI tutor features are available at no cost. We believe quality education should be accessible to everyone."
    },
    {
      question: "What study materials are available on JEE Challenger?",
      answer: "JEE Challenger offers comprehensive study materials for Physics, Chemistry, and Mathematics. This includes chapter-wise study notes, formula sheets, quick revision materials, and a custom-built PYQ question bank."
    },
    {
      question: "How can I prepare for JEE without coaching using JEE Challenger?",
      answer: "You can prepare for JEE completely free using JEE Challenger by: 1) Following our comprehensive study materials for all subjects, 2) Using the syllabus tracker to monitor your progress, 3) Practicing extensively with our integrated previous year question bank, 4) Getting instant doubt resolution through our AI tutor, 5) Staying updated with latest JEE news and exam patterns."
    },
    {
      question: "What is the AI Tutor feature?",
      answer: "The AI Tutor is an intelligent assistant that helps solve JEE doubts 24/7. It provides step-by-step solutions for Physics, Chemistry, and Mathematics problems, supports LaTeX for mathematical expressions, accepts file uploads for questions, and maintains your chat history for reference."
    },
    {
      question: "How do I track my JEE preparation progress?",
      answer: "Use the Syllabus Tracker feature to monitor your preparation across all 88 chapters of Physics (29 chapters), Chemistry (30 chapters), and Mathematics (29 chapters). Mark your progress for Theory, PYQs, and Revision separately, and visualize your completion percentage with progress indicators."
    },
    {
      question: "Are previous year questions important for JEE?",
      answer: "Yes! Previous year questions (PYQs) are crucial for JEE preparation. They help you understand exam patterns, frequently asked topics, difficulty levels, and time management. JEE Challenger provides its own comprehensive, built-in question bank of previous year questions to help you practice effectively."
    },
    {
      question: "Can I access JEE Challenger on mobile?",
      answer: "Yes! JEE Challenger is fully mobile-responsive and works seamlessly on all devices including smartphones, tablets, and desktops. You can access all features through your mobile browser without needing to download any app."
    }
  ]
};

export const physicsFAQs = {
  questions: [
    {
      question: "What are the best books for JEE Physics?",
      answer: "The best books for JEE Physics are: 1) HC Verma (Concepts of Physics Vol 1 & 2) for conceptual understanding, 2) DC Pandey for problem-solving practice, 3) NCERT Physics (Class 11 & 12) for basics, 4) I.E. Irodov for JEE Advanced level problems, and 5) Previous 43 years chapter-wise solved papers."
    },
    {
      question: "Is HC Verma enough for JEE Advanced Physics?",
      answer: "HC Verma is excellent for building strong concepts but alone may not be sufficient for JEE Advanced. You should combine it with: NCERT for basics, DC Pandey or Irodov for advanced problems, and extensive practice of previous year questions. JEE Challenger provides comprehensive notes and a built-in PYQ question bank to complement your textbook studies."
    },
    {
      question: "How to solve JEE Physics numericals effectively?",
      answer: "To solve JEE Physics numericals: 1) Master fundamental concepts first from NCERT and HC Verma, 2) Understand the theory behind formulas, don't just memorize, 3) Practice chapter-wise problems systematically, 4) Solve previous year questions, 5) Use dimensional analysis and approximations, 6) Practice time management. Use our AI Tutor for instant doubt resolution."
    },
    {
      question: "Which topics are most important in JEE Physics?",
      answer: "High-weightage topics in JEE Physics include: Mechanics (20-25%), Electrodynamics (18-20%), Modern Physics (15-18%), Optics (12-15%), Thermodynamics (10-12%), and Waves (8-10%). Focus on Rotational Motion, Electrostatics, Current Electricity, Ray & Wave Optics, and Modern Physics for maximum marks."
    },
    {
      question: "How many chapters are there in JEE Physics syllabus?",
      answer: "JEE Physics syllabus contains 29 chapters total: 14 from Class 11 (Mechanics, Thermodynamics, Waves) and 15 from Class 12 (Electromagnetism, Optics, Modern Physics). You can track your progress across all chapters using our Syllabus Tracker."
    }
  ]
};

export const chemistryFAQs = {
  questions: [
    {
      question: "What are the best books for JEE Chemistry?",
      answer: "Best books for JEE Chemistry: 1) NCERT Chemistry (Class 11 & 12) - mandatory foundation, 2) OP Tandon for Physical Chemistry, 3) MS Chouhan for Organic Chemistry, 4) JD Lee for Inorganic Chemistry, 5) Previous year solved papers."
    },
    {
      question: "Is NCERT enough for JEE Chemistry?",
      answer: "NCERT is absolutely essential for JEE Chemistry and covers 40-45% of questions directly. However, for JEE Advanced and scoring 100%, combine NCERT with: OP Tandon for Physical Chemistry calculations, MS Chouhan for Organic reactions, and practice previous year questions extensively."
    },
    {
      question: "How to prepare Organic Chemistry for JEE?",
      answer: "To master Organic Chemistry for JEE: 1) Learn basic concepts and nomenclature from NCERT, 2) Understand reaction mechanisms, not just products, 3) Master named reactions with conditions, 4) Create reaction charts/flowcharts, 5) Practice isomerism and stereochemistry thoroughly, 6) Solve previous year questions. Use our AI Tutor for mechanism explanations."
    },
    {
      question: "Which is easier: Physical, Organic, or Inorganic Chemistry for JEE?",
      answer: "It varies by student. Physical Chemistry is math-based and scoring if you're good with calculations. Organic Chemistry requires understanding patterns and mechanisms. Inorganic Chemistry needs memorization but is very scoring. Most students find Physical Chemistry easier to score in with practice."
    },
    {
      question: "How many chapters are in JEE Chemistry syllabus?",
      answer: "JEE Chemistry has 30 chapters: 14 from Class 11 (Basic concepts, Physical Chemistry basics, Organic fundamentals, Inorganic chemistry) and 16 from Class 12 (Advanced Physical, Organic reactions, Inorganic chemistry). Track all chapters with our Syllabus Tracker feature."
    }
  ]
};

export const mathematicsFAQs = {
  questions: [
    {
      question: "What are the best books for JEE Mathematics?",
      answer: "Best books for JEE Maths: 1) NCERT (Class 11 & 12) for concepts, 2) RD Sharma for practice, 3) Cengage Series for topic-wise depth, 4) Arihant Skills in Mathematics, 5) TMH (Tata McGraw Hill) for objective problems, 6) Previous year solved papers."
    },
    {
      question: "Is RD Sharma enough for JEE Maths?",
      answer: "RD Sharma is good for JEE Main but insufficient for JEE Advanced. For JEE Advanced, combine RD Sharma with: NCERT for basics, Cengage for advanced concepts, and extensive previous year question practice. Focus on developing problem-solving skills, not just formula application."
    },
    {
      question: "Which topics are most important in JEE Mathematics?",
      answer: "High-scoring JEE Maths topics: Calculus (25-30% weightage) - Limits, Differentiation, Integration, Differential Equations; Algebra (25-30%) - Complex Numbers, Quadratic Equations, Sequences; Coordinate Geometry (20-25%); Trigonometry (15-20%); Vectors & 3D (10-15%). Master Calculus and Algebra for maximum marks."
    },
    {
      question: "How to score 100/100 in JEE Maths?",
      answer: "To score full marks in JEE Maths: 1) Master NCERT thoroughly (50% questions are NCERT-based), 2) Understand concepts deeply, don't just memorize formulas, 3) Practice 500+ problems per chapter, 4) Solve previous 20 years' papers, 5) Focus on speed and accuracy, 6) Revise formulas daily, 7) Attempt mock tests regularly."
    },
    {
      question: "How many chapters are in JEE Maths syllabus?",
      answer: "JEE Mathematics contains 29 chapters: 14 from Class 11 (Algebra, Trigonometry, Coordinate Geometry basics, Calculus introduction) and 15 from Class 12 (Advanced Calculus, 3D Geometry, Vectors, Probability). Monitor your chapter-wise preparation using our Syllabus Tracker."
    }
  ]
};

export const pyqFAQs = {
  questions: [
    {
      question: "Why are previous year questions important for JEE?",
      answer: "PYQs are crucial because they: 1) Reveal exam patterns and question trends, 2) Show frequently asked topics and weightage, 3) Help understand difficulty levels, 4) Improve time management skills, 5) Build confidence through familiar question types, 6) Highlight important concepts tested repeatedly. JEE Challenger provides a structured question bank of previous year questions for rigorous practice."
    },
    {
      question: "How many years of PYQs should I solve for JEE?",
      answer: "Solve at least 15-20 years of PYQs for JEE Main and 10-15 years for JEE Advanced. For best results, solve them chapter-wise (not year-wise) to master topic patterns. JEE Challenger provides a custom-built PYQ question bank meticulously organized for systematic practice."
    },
    {
      question: "Where can I get previous year questions for free?",
      answer: "JEE Challenger provides a comprehensive question bank of Previous Year Questions (PYQs) for all three subjects - Physics, Chemistry, and Mathematics. Our integrated platform allows you to practice authentic questions chapter-wise and year-wise directly on the website."
    },
    {
      question: "Should I solve PYQs year-wise or chapter-wise?",
      answer: "Solve previous year questions during preparation phase to master each topic's pattern. Switch to year-wise solving during final months (3-4 months before exam) as full-length mock tests for time management and exam simulation. JEE Challenger provides both formats."
    },
    {
      question: "When should I start solving JEE previous year questions?",
      answer: "Start solving PYQs after completing each chapter's theory and basic practice problems. Don't wait until syllabus completion. Solving previous year questions immediately after studying a topic helps reinforce concepts and identify weak areas early."
    }
  ]
};

export const aiTutorFAQs = {
  questions: [
    {
      question: "How does the JEE Challenger AI Tutor work?",
      answer: "The AI Tutor uses advanced artificial intelligence to provide instant JEE doubt resolution. Simply type or upload your question (with images), and get step-by-step solutions with explanations. It supports LaTeX for mathematical expressions, maintains chat history, and works 24/7 for Physics, Chemistry, and Mathematics problems."
    },
    {
      question: "Is the AI Tutor free to use?",
      answer: "Yes! The AI Tutor offers a generous free tier for all students. Basic features including doubt solving, step-by-step solutions, and chat history are available free. Premium features may have usage limits which can be upgraded if needed."
    },
    {
      question: "Can I upload images of questions to the AI Tutor?",
      answer: "Yes! The AI Tutor supports file uploads including images of handwritten or printed questions. Simply click the attachment button, upload your question image, and the AI will analyze and solve it with detailed explanations."
    },
    {
      question: "Does the AI Tutor provide step-by-step solutions?",
      answer: "Yes! The AI Tutor provides detailed step-by-step solutions for all problems. It explains the concept, shows the solving process, highlights important formulas, and provides final answers with proper mathematical formatting using LaTeX."
    },
    {
      question: "What subjects does the AI Tutor cover?",
      answer: "The AI Tutor covers all three JEE subjects: Physics (Mechanics, Electromagnetism, Modern Physics, etc.), Chemistry (Physical, Organic, Inorganic), and Mathematics (Calculus, Algebra, Coordinate Geometry, Trigonometry, etc.). It can solve problems from entire JEE Main and Advanced syllabus."
    }
  ]
};

export const syllabusTrackerFAQs = {
  questions: [
    {
      question: "How does the JEE Syllabus Tracker work?",
      answer: "The Syllabus Tracker helps you monitor preparation progress across all 88 chapters of Physics (29), Chemistry (30), and Mathematics (29). Mark each chapter's completion for Theory, PYQs, and Revision separately. View subject-wise and overall progress with visual indicators. All data is saved locally in your browser."
    },
    {
      question: "Can I export my syllabus tracker progress?",
      answer: "Yes! The Syllabus Tracker allows you to export your progress data as a JSON file, which you can save as backup or share. You can also import previously exported data to restore your progress or sync across devices."
    },
    {
      question: "Is my syllabus tracker data saved?",
      answer: "Yes! Your progress is automatically saved in your browser's local storage. Data persists even after closing the browser. For additional security, export your data regularly as backup using the export feature."
    },
    {
      question: "What are Theory, PYQs, and Revision in the tracker?",
      answer: "Theory: Mark when you've completed studying chapter concepts from books/notes. PYQs: Mark after solving previous year questions for that chapter. Revision: Mark after revising the chapter before exams. This 3-stage tracking ensures comprehensive preparation for each chapter."
    },
    {
      question: "How can the Syllabus Tracker improve my JEE preparation?",
      answer: "It improves preparation by: 1) Providing clear visibility of completed and pending chapters, 2) Motivating through progress visualization, 3) Preventing chapter skipping, 4) Helping plan revision schedules, 5) Showing weak areas needing more focus, 6) Tracking 3 stages: Theory, PYQs, and Revision completion."
    }
  ]
};

export const newsFAQs = {
  questions: [
    {
      question: "How often is JEE news updated on JEE Challenger?",
      answer: "JEE news is updated in real-time using the GNews API. New articles appear automatically as they're published by reliable news sources. The news section covers exam dates, registration deadlines, admit cards, results, cutoffs, counseling updates, and important JEE-related announcements."
    },
    {
      question: "What type of JEE news is available?",
      answer: "JEE Challenger provides comprehensive news including: JEE Main and Advanced exam dates, registration and application deadlines, admit card releases, answer key announcements, result declarations, cutoff scores, counseling schedules, syllabus changes, exam pattern updates, and important NTA/IIT notifications."
    },
    {
      question: "How can I stay updated with latest JEE notifications?",
      answer: "Stay updated by: 1) Regularly checking our News section with real-time updates, 2) Joining our Telegram channel @jeechallenger for instant notifications, 3) Bookmarking the news page for quick access, 4) Checking official links section for NTA and IIT websites directly."
    }
  ]
};
